import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IInternationalStudentPage,
  IStrapiDocument,
} from 'src/app/interfaces/strapi';
import StrapiService from 'src/app/services/strapi.service';
import { NgSwitch, NgSwitchCase, NgIf } from '@angular/common';
import { ModalComponent } from '../../../shared/components/modal/modal.component';

enum MakeAClaimEnum {
  BUTTON = 'BUTTON',
  CLAIM_NUMBER = 'CLAIM_NUMBER',
  NONE = 'NONE',
}
export interface IMakeAClaimButton {
  button_text: string | null;
  show_button: boolean | null;
}

@Component({
    selector: 'app-make-a-claim-card',
    templateUrl: './make-a-claim-card.component.html',
    styleUrls: ['./make-a-claim-card.component.scss'],
    imports: [
        NgSwitch,
        NgSwitchCase,
        ModalComponent,
        NgIf,
    ],
})
export class MakeAClaimCardComponent implements OnInit {
  @Input() public cardTitle: string = '';

  @Input() public cardExcerpt: string = '';

  @Input() public cardClaimNumber: string = '';

  @Input() public cardButton: IMakeAClaimButton = <IMakeAClaimButton>{};

  public MakeAClaimEnum = MakeAClaimEnum;

  public makeAClaimConfirmationText: string = '';

  public makeAClaimNoConfirmationText: string = '';

  public showId: string = '';

  public buttonLink: string = '';

  public showConfirm = false;

  public showNoConfirmation = false;

  constructor(private strapi: StrapiService, public router: Router) {}

  ngOnInit(): void {
    if (this.cardButton.show_button) {
      this.showId = this.MakeAClaimEnum.BUTTON;
      this.strapi.getInternationalStudentPage().subscribe({
        next: (data: IStrapiDocument<IInternationalStudentPage>) => {
          this.makeAClaimConfirmationText =
            data.data.attributes.make_a_claim_form_popup_text ?? '';
          this.makeAClaimNoConfirmationText =
            data.data.attributes.make_a_claim_form_popup_text_no ?? '';
        },
      });
    } else if (this.cardClaimNumber) {
      this.showId = this.MakeAClaimEnum.CLAIM_NUMBER;
    } else {
      this.showId = this.MakeAClaimEnum.NONE;
    }
  }

  public showConfirmModel(): void {
    this.showConfirm = true;
  }

  public navigateYes(): void {
    this.router
      .navigate(['/app/international-student/make-a-claim'])
      .finally(() => false);
  }

  public navigateNo(): void {
    this.showNoConfirmation = true;
  }

  public confirmModalClosed(): void {
    this.showConfirm = false;
    this.showNoConfirmation = false;
  }
}
